import { Box, Dialog, DialogContent, DialogTitle, Divider, Grid, InputAdornment, ListItemIcon, Menu, MenuItem, Paper, Toolbar, Typography } from '@mui/material'
import { icons } from '../../constants/images'
import AutocompleteSelect from '../select/autoCompleteSelect'
import React, { useCallback, useEffect, useState } from 'react';
import FilterSelect from '../select/filterSelect';
import ButtonCustom from '../button/buttonCustom';
import InputTextField from '../input/inputTextField';
import { useNavigate } from 'react-router-dom';
import InputDatePicker from '../input/inputDatePicker';
import moment from 'moment';
import ClearIcon from '@mui/icons-material/Clear';
import { useSelector } from 'react-redux';
import { logout } from '../../utils/app.utils';
import { Logout } from '@mui/icons-material';
import SearchApi from '../../api/search/search.api';
import AdvanceSearch from './advanceSearch';

const CustomPaper = (props: any) => {
  const { children, handleClickOpen, ...other } = props;

  return (
    <Paper elevation={2} {...other}>
      {/* {children} */}
      <div style={{ padding: "12px 14px", marginTop: "-8px", display:'flex', gap:'10px' }} onMouseDown={() => handleClickOpen()}>
        {/* <Typography sx={{ fontWeight: '800', cursor: "pointer", }}>ค้นหา</Typography> */}
        <Typography sx={{ fontWeight: '800', cursor: "pointer", }}>ค้นหาขั้นสูง</Typography>
      </div>
    </Paper >
  );
};
interface propsTypes {
  setDrawerOpen: any
  drawerOpen: boolean
  url:string
}
export default function Header(props: propsTypes) {
  const navigate = useNavigate();
  const [edate, setEdate] = useState<string>('');
  const [keyword, setKeyword] = useState<string>('');

  const [open, setOpen] = useState(false);
  const [data, setData] = useState(false);
  const { setDrawerOpen, drawerOpen, url } = props
  const { profile } = useSelector((state: any) => state.profile)
  // const profile = JSON.parse(getProfile() || '')
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const openMenu = Boolean(anchorEl);
  const handleClickMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  // const loadData = useCallback(async () => {
  //   let condition: any = {};
  //   if (keyword) condition = { ...condition, keyword: keyword };

  //   SearchApi.getSearch(condition).then((res) => {
  //     if (res?.data?.success) {
  //       const data = res.data.result;
  //       setData(data);

  //     }
  //   });
  // }, [keyword]);

  // useEffect(() => {
  //   loadData()
  // }, [loadData])


  console.log(keyword);
  return (
    <Toolbar sx={{
      width: "100%", borderBottom: '1px solid var(--C1, #026735)',
      boxShadow: '0px 1px 3px 0px rgba(16, 24, 40, 0.10), 0px 1px 2px -1px rgba(16, 24, 40, 0.10)',
      padding: '12px 44px !important',
      justifyContent: "space-between"
    }}>
      <Box sx={{
        display: 'flex', alignItems: "center", padding: "6.5px 0px",
      }}>
        <icons.burgerMenu onClick={() => setDrawerOpen(!drawerOpen)} style={{ marginRight: '20px' }} />
        <Box sx={{ display: { lg: 'none', xs: 'flex' }, alignItems: 'center', justifyContent: "center", border: '1px solid #7e7e7e', borderRadius: '5px', width: "32px", height: '32px', }}>
          <icons.search onClick={() => { handleClickOpen() }} />
        </Box>
        <Box sx={{ display: { lg: 'block', xs: 'none' } }}>
          <AutocompleteSelect placeholder='ค้นหา'
            options={[{name:keyword}]}
            // getOptionLabel={(option) => option.name}
            // onChange={(e: any, newValue: any) => {

            //   navigate('/shared-documents', { state: { folderPath: newValue?.folderPath?.split('/') || [] } })
            // }}
            onKeyDown={(e:any) => {
            if (e.key === 'Enter') {
              e.preventDefault(); // กัน form submit (ถ้ามี)
              setKeyword(e.target.value)
              // navigate('/shared-documents', { state: { folderPath: newValue?.folderPath?.split('/') || [] } })
                   navigate('/search-results', {
                                state: {
                                    keyword: e.target.value,
                                        sdate: '',
                                    edate: '',
                                    keywordIndex: '',
                                    keywordLevel1: '',
                                    keywordLevel1v: null,
                                    keywordLevel2: '',
                                    keywordLevel2v: null,
                                    keywordLevel3: '',
                                    keywordLevel3v: null,
                                    keywordLevel4: '',
                                    keywordLevel4v: null,
                                    fileLocation: '',
                                    folderLocation: '',
                                    idDocumentType: '',
                                    idSearchType: ''}})
            }
          }}
            renderOption={(props, option) => {
              return (
                <li {...props}
                  style={{
                    padding: "12px",
                    borderBottom: "1px solid #E5E5E7",
                    width: "100%",
                  }}
                >
                  {option.level === '0' ? <icons.Building style={{ marginRight: "12px" }} /> :
                    option.level === '1' ? <icons.Building style={{ marginRight: "12px" }} /> :
                      option.level === '2' ? <icons.listFolder style={{ marginRight: "12px" }} /> :
                        option.level === '3' ? <icons.Folder style={{ marginRight: "12px" }} /> :
                          <icons.double style={{ marginRight: "12px" }} />
                  }
                  <div>
                    <Typography sx={{ fontSize: '16px' }}>{option?.name}</Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: '300' }}>{option?.type === 'file' ? moment(option?.description).add('year', 543).format('DD MMM YYYY') : option?.description}</Typography>
                  </div>
                </li>
              );
            }}
            freeSolo
            inputValue={keyword}
            onInputChange={(e: any, newValue: any) => {
              setKeyword(newValue)}}
            PaperComponent={(props: any) => <CustomPaper {...props} handleClickOpen={handleClickOpen} />}
            labelId={''}
            width={376}
            InputProps={
              <InputAdornment position="start" sx={{ marginLeft: '8px', cursor:'pointer' }} onClick={() => {
                 navigate('/search-results', {
                                state: {
                                    keyword: keyword,
                                        sdate: '',
                                    edate: '',
                                    keywordIndex: '',
                                    keywordLevel1: '',
                                    keywordLevel1v: null,
                                    keywordLevel2: '',
                                    keywordLevel2v: null,
                                    keywordLevel3: '',
                                    keywordLevel3v: null,
                                    keywordLevel4: '',
                                    keywordLevel4v: null,
                                    fileLocation: '',
                                    folderLocation: '',
                                    idDocumentType: '',
                                    idSearchType: ''
                                  }})
            
              }}>
                <icons.search />
              </InputAdornment>
            }
          />
        </Box>


      </Box>
      <div style={{ display: 'flex', alignItems: "center" }}>
        <div style={{ display: 'flex', alignItems: "center", marginRight: '12px', cursor: "pointer" }} onClick={() => window.open(`${url}/index-manual`, '_blank')}>
          <icons.h_archive />
          <Typography sx={{ color: '#525D6A', marginLeft: '4px', display: { lg: 'block', xs: 'none' } }}>ดัชนีเอกสาร</Typography>
        </div>
        <div style={{ display: 'flex', alignItems: "center", marginRight: '12px', cursor: "pointer" }} onClick={() => window.open(`${url}/user-manual`, '_blank')}>
          <icons.h_book />
          <Typography sx={{ color: '#525D6A', marginLeft: '4px', display: { lg: 'block', xs: 'none' } }}>คู่มือการใช้งาน</Typography>
        </div>
        <icons.noti style={{ cursor: 'pointer' }} onClick={() => {
          navigate('/notifications')
        }} />
        <Divider orientation="vertical" variant="fullWidth" flexItem sx={{
          background: 'var(--background-light-disabled, #E5E5E7)', borderWidth: "1px", marginLeft: '12px',
          marginRight: '12px',
        }} />
        <div onClick={handleClickMenu} style={{ display: 'flex', alignItems: "center", cursor: "pointer" }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: "42px",
            height: '42px',
            borderRadius: 'var(--roundness-full-inside, 128px)',
            borderTop: '1px solid var(--stroke-light-base, #E5E5E7)',
            borderRight: '1px solid var(--stroke-light-base, #E5E5E7)',
            borderBottom: '1px solid var(--stroke-light-base, #E5E5E7)',
            borderLeft: '1px solid var(--stroke-light-base, #E5E5E7)',
            background: 'var(--background-light-base-second, #F8F9FB)',
          }}>
            <icons.userFill />
          </div>

          <Box sx={{ marginLeft: '8px', marginRight: "8px", display: { md: 'block', xs: 'none' } }}>
            <Typography sx={{ color: "#026735" }}>{profile?.employeeFirstname} {profile?.employeeLastname}</Typography>
            <Typography sx={{ color: "#858C95", fontSize: '12px' }}>{profile?.department?.departmentName}</Typography>
          </Box>
          <icons.profileDown />
        </div>
        <Menu
          anchorEl={anchorEl}
          id="account-menu"
          open={openMenu}
          onClose={handleCloseMenu}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: 'visible',
              filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              mt: 1.5,
              '& .MuiAvatar-root': {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              '&::before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: 'background.paper',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0,
              },
            },
          }}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
          {/* <MenuItem onClick={() => {}}>
          <ListItemIcon>
            <PersonAdd fontSize="small" />
          </ListItemIcon>
          บัญชีผู้ใช้
        </MenuItem> */}
          <MenuItem onClick={() => logout()}>
            <ListItemIcon>
              <Logout fontSize="small" />
            </ListItemIcon>
            ออกจากระบบ
          </MenuItem>
        </Menu>
      </div>
      <AdvanceSearch open={open} handleClose={handleClose} />
    </Toolbar>
  )
}
